import { Controller } from "@hotwired/stimulus";
import { getRandomWords } from "../utils/word_list";

// Connects to data-controller="password-generator"
export default class extends Controller {
  static targets = [
    "passwordDisplay",
    "passwordText",
    "passwordField",
    "passwordConfirmationField",
    "copyFeedback",
  ];

  generate() {
    const words = getRandomWords(4);
    const password = words.join("-");

    this.passwordTextTarget.textContent = password;
    this.passwordFieldTarget.value = password;
    this.passwordConfirmationFieldTarget.value = password;
    this.passwordDisplayTarget.classList.remove("hidden");
  }

  async copy() {
    const password = this.passwordTextTarget.textContent;

    try {
      await navigator.clipboard.writeText(password);
      this.copyFeedbackTarget.classList.remove("hidden");
      setTimeout(() => {
        this.copyFeedbackTarget.classList.add("hidden");
      }, 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  }
}
